export class IncomeDateRangeValidationService {
  private _start: Date;
  private _end: Date;
  private _rangeMap: Map<string, boolean> = new Map<string, boolean>();

  constructor(start: Date, end: Date) {
    this._start = start;
    this._end = end;
    this.createDateRangeMap();
  }
  public validate(dateRanges: DateRange[]) {
    if (!dateRanges || dateRanges.length == 0) return false;

    dateRanges.forEach(dataRange => {
      let loopDate = new Date(dataRange.start);
      loopDate.setDate(1);
      const endDate = new Date(dataRange.end);
      while (loopDate <= endDate) {
        const rangeKey = `${loopDate.getFullYear().toString()}_${loopDate
          .getMonth()
          .toString()}`;
        if (this._rangeMap.has(rangeKey)) {
          this._rangeMap.set(rangeKey, true);
        }
        loopDate.setMonth(loopDate.getMonth() + 1);
      }
    });

    for (const [key, value] of this._rangeMap) {
      if (!value) return false;
    }

    return true;
  }

  private createDateRangeMap() {
    let loopDate = new Date(this._start);
    const endDate = new Date(this._end);

    while (loopDate <= endDate) {
      this._rangeMap.set(
        `${loopDate.getFullYear().toString()}_${loopDate
          .getMonth()
          .toString()}`,
        false,
      );
      loopDate.setMonth(loopDate.getMonth() + 1);
    }
  }
}

export class DateRange {
  start: Date;
  end: Date;

  constructor(start: Date, end: Date) {
    this.start = start;
    this.end = end;
  }
}
